// extracted by mini-css-extract-plugin
export default {"continue":"Setup_continue__3o27q","nameInput":"Setup_nameInput__8s20s","addButton":"Setup_addButton__P5y9X","form":"Setup_form__bMknt"};